import React from 'react'

import { PriceString } from '@fourthwall/components'

import * as S from './CostsBreakdownTooltipContent.styled'

type CostsBreakdownTooltipContent = {
  items: { label: string; value: number }[]
}

export const CostsBreakdownTooltipContent = ({ items }: CostsBreakdownTooltipContent) => (
  <S.Container>
    {items.map((item) => (
      <S.Item key={item.label}>
        <S.Label>{item.label}</S.Label>
        <S.Value>
          <PriceString value={item.value} />
        </S.Value>
      </S.Item>
    ))}
  </S.Container>
)
